import { INavRoute } from 'app/components'
import { Dashboard } from 'app/containers/Dashboard'
import { FirstPage } from 'app/containers/FirstPage'
import { Introduction } from 'app/containers/Introduction'
import { PipelineSection } from 'app/containers/PipelineSection'
import { ProfileSettings } from 'app/containers/ProfileSettings'
import { Support } from 'app/containers/Support'
import { UserLogin } from 'app/containers/UserLogin'
import { UserActions } from 'app/redux/User/actions'
import { getPipelineConfig } from 'config'
import { IPipelineInstance } from 'config/interfaces'
import * as React from 'react'

const currentPipelineConfig = getPipelineConfig()

const LoggedOutAppNavRoutes: INavRoute[] = [
  {
    default: true,
    single: {
      name: 'Login',
      component: UserLogin,
      path: '/login',
      icon: 'fa fa-fw fa-sign-in',
    }
  },
]

const ShowAlwaysRoutes: INavRoute[] = [
  {
    single: {
      name: 'Help & Support',
      component: Support,
      path: '/support',
      icon: 'fa fa-fw fa-medkit'
    }
  }
]

const LoggedInAppNavRoutes: INavRoute[] = [
  {
    default: true,
    hidden: true,
    single: {
      name: 'FirstPage',
      component: FirstPage,
      path: '/firstPage',
      icon: 'fa fa-fw fa-star-o'
    }
  },
  {
    single: {
      name: 'Introduction',
      component: Introduction,
      path: '/introduction',
      icon: 'fa fa-fw fa-star-o'
    }
  },
  {
    single: {
      name: 'Dashboard',
      component: Dashboard,
      path: '/dashboard',
      icon: 'fa fa-fw fa-dashboard'
    }
  },
  {
    hidden: true,
    single: {
      name: 'Profile',
      component: ProfileSettings,
      path: '/profile',
      icon: ''
    }
  },
  ...PipelineSection.getNavRoutesFor(currentPipelineConfig),
  ...ShowAlwaysRoutes
]

export {
  LoggedInAppNavRoutes,
  LoggedOutAppNavRoutes,
  ShowAlwaysRoutes
}



// WEBPACK FOOTER //
// ./src/app/containers/RetirementApp/routes.tsx